// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface OrganizationSettingsDTO
 */
export interface OrganizationSettingsDTO {
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSettingsDTO
     */
    mediationEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSettingsDTO
     */
    pricingRule?: OrganizationSettingsDTOPricingRuleEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSettingsDTO
     */
    commissionRule?: OrganizationSettingsDTOCommissionRuleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSettingsDTO
     */
    topUpEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSettingsDTO
     */
    extendedInitialTenancyTermEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSettingsDTO
     */
    autoExtendOutcomeDeadlineEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSettingsDTO
     */
    maximumPolicyCover?: OrganizationSettingsDTOMaximumPolicyCoverEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSettingsDTO
     */
    offerRepositEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSettingsDTO
     */
    marketRentCalculatorEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSettingsDTO
     */
    inventoryChaserDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSettingsDTO
     */
    delayedInventoryConfirmationEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSettingsDTO
     */
    minimumFeeDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSettingsDTO
     */
    pendingSwitchRemindersDisabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationSettingsDTO
     */
    allowedTenancyTermTypes?: Array<OrganizationSettingsDTOAllowedTenancyTermTypesEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum OrganizationSettingsDTOPricingRuleEnum {
    STANDARD = 'STANDARD',
    STANDARDCAP250 = 'STANDARD_CAP_250',
    STANDARDCAP300 = 'STANDARD_CAP_300',
    STANDARDCAP350 = 'STANDARD_CAP_350',
    NOMINALPERTENANT = 'NOMINAL_PER_TENANT',
    STANDARD15PERCENTDISCOUNT = 'STANDARD_15_PERCENT_DISCOUNT'
}
/**
    * @export
    * @enum {string}
    */
export enum OrganizationSettingsDTOCommissionRuleEnum {
    FEEPERCENTAGE125 = 'FEE_PERCENTAGE_125',
    FEEPERCENTAGE31POINT75 = 'FEE_PERCENTAGE_31_POINT_75',
    FEEPERCENTAGE30 = 'FEE_PERCENTAGE_30',
    FEEPERCENTAGE25 = 'FEE_PERCENTAGE_25',
    FEEPERCENTAGE20 = 'FEE_PERCENTAGE_20',
    FEEPERCENTAGE17POINT5 = 'FEE_PERCENTAGE_17_POINT_5',
    FEEPERCENTAGE16 = 'FEE_PERCENTAGE_16',
    FEEPERCENTAGE15 = 'FEE_PERCENTAGE_15',
    FEEPERCENTAGE12POINT5 = 'FEE_PERCENTAGE_12_POINT_5',
    FEEPERCENTAGE10 = 'FEE_PERCENTAGE_10',
    FEEPERCENTAGE5 = 'FEE_PERCENTAGE_5',
    FIXED25 = 'FIXED_25',
    PPMPERCENTAGE6 = 'PPM_PERCENTAGE_6',
    PPMPERCENTAGE6POINT5 = 'PPM_PERCENTAGE_6_POINT_5',
    NOCOMMISSION = 'NO_COMMISSION'
}
/**
    * @export
    * @enum {string}
    */
export enum OrganizationSettingsDTOMaximumPolicyCoverEnum {
    TENTHOUSANDPOUNDS = 'TEN_THOUSAND_POUNDS',
    FIVETHOUSANDPOUNDS = 'FIVE_THOUSAND_POUNDS'
}
/**
    * @export
    * @enum {string}
    */
export enum OrganizationSettingsDTOAllowedTenancyTermTypesEnum {
    FIXED = 'FIXED',
    PERIODIC = 'PERIODIC'
}



